import departments from './account-departments.js';
const account_center = {
    departments,
    home: {
        title: '页面未找到',
        description: '此页面不可用。',
    },
    page: {
        title: '账户',
        security_title: '安全',
        security_description: '你可以在这里修改账户设置，以确保账户安全。',
        profile_title: '个人信息',
        profile_description: '在这里更改你的个人信息。',
        sidebar_personal_info: '个人信息',
        sidebar_security: '安全',
        sidebar_sessions: '会话',
        support: '支持',
        user_menu: '用户菜单',
        sign_out: '退出登录',
    },
    verification: {
        title: '安全验证',
        description: '为保护账户安全，请确认是您本人。请选择验证身份的方法。',
        error_send_failed: '验证码发送失败，请稍后再试。',
        error_invalid_code: '验证码无效或已过期。',
        error_verify_failed: '验证失败，请重新输入验证码。',
        verification_required: '验证已失效，请重新验证身份。',
        try_another_method: '尝试其他验证方式',
        no_available_methods_title: '没有可用的验证方式',
        no_available_methods_description: '你尚未设置任何验证方式。请先为你的账户添加密码、邮箱或手机号。',
    },
    password_verification: {
        title: '验证密码',
        description: '为保护账户安全，请输入您的密码完成验证。',
        error_failed: '密码错误，请重新输入。',
    },
    verification_method: {
        password: {
            name: '密码',
            description: '验证您的密码',
        },
        email: {
            name: '邮箱验证码',
            description: '发送验证码到您的邮箱',
        },
        phone: {
            name: '手机验证码',
            description: '发送验证码到您的手机号码',
        },
    },
    email: {
        title: '关联邮箱',
        description: '关联邮箱以用于登录或帮助找回账号。',
        verification_title: '输入邮箱验证码',
        verification_description: '验证码已发送到你的邮箱 {{email_address}}。',
        success: '已成功关联主要邮箱。',
        verification_required: '验证已失效，请重新验证身份。',
    },
    phone: {
        title: '关联手机号',
        description: '关联手机号用于登录或帮助找回账号。',
        verification_title: '输入短信验证码',
        verification_description: '验证码已发送到你的手机 {{phone_number}}。',
        success: '已成功关联主要手机号。',
        verification_required: '验证已失效，请重新验证身份。',
    },
    username: {
        title: '设置用户名',
        description: '用户名只能包含字母、数字和下划线。',
        policy_description: '{{requirements}}',
        success: '用户名更新成功。',
    },
    security: {
        add: '添加',
        change: '更改',
        remove: '移除',
        not_set: '未设置',
        social_sign_in: '社交登录',
        social_not_linked: '未关联',
        email_phone: '邮箱 / 手机号',
        email: '邮箱',
        phone: '手机号',
        password: '密码',
        configured: '已设置',
        not_configured: '未设置',
        two_step_verification: '两步验证',
        authenticator_app: '身份验证器应用',
        passkeys: '通行密钥',
        backup_codes: '备用码',
        email_verification_code: '邮箱验证码',
        phone_verification_code: '手机验证码',
        passkeys_count_one: '{{count}} 个通行密钥',
        passkeys_count_other: '{{count}} 个通行密钥',
        backup_codes_count_one: '{{count}} 个备用码',
        backup_codes_count_other: '{{count}} 个备用码',
        view: '查看',
        manage: '管理',
        turn_on_2_step_verification_description: '增加一层额外的安全保护。登录时将要求进行第二步验证。',
        turn_off_2_step_verification: '关闭两步验证',
        turn_off_2_step_verification_description: '关闭两步验证将移除登录时账户的额外保护层。确定要继续吗？',
        disable_2_step_verification: '关闭',
        no_verification_method_warning: '你尚未添加第二种验证方式。请至少添加一种以在登录时启用两步验证。',
        passkey_sign_in_prompt: '提示设置通行密钥',
        passkey_sign_in_prompt_description: '开启后，系统会提示你设置通行密钥，以实现更快速、更安全的登录。',
        account_removal: '账号删除',
        delete_your_account: '删除你的账号',
        delete_account: '删除账号',
        remove_username_confirmation_title: '移除用户名',
        remove_username_confirmation_description: '移除后，你将无法再使用此用户名登录。确定要继续吗？',
        remove_email_confirmation_title: '移除邮箱地址',
        remove_email_confirmation_description: '移除后，你将无法再使用此邮箱地址登录。确定要继续吗？',
        remove_phone_confirmation_title: '移除手机号',
        remove_phone_confirmation_description: '移除后，你将无法再使用此手机号登录。确定要继续吗？',
        email_removed: '邮箱地址已成功移除。',
        phone_removed: '手机号已成功移除。',
        username_removed: '用户名已成功移除。',
        trusted_devices: {
            title: 'MFA 受信任设备',
            current_device: '当前设备',
            expires_on: '于 {{date}} 到期',
            unknown_location: '未知位置',
            remove: '移除',
            removed: '受信任设备已成功移除。',
            loading: '加载中...',
            empty: '暂无受信任设备。',
            load_failed: '受信任设备加载失败，请重试。',
            retry: '重试',
            remove_confirmation_title: '移除受信任设备？',
            remove_confirmation_description: '下次在此设备上登录时，你需要再次完成 MFA。当前会话将保持有效。',
        },
    },
    social: {
        linked: '已成功关联 {{connector}}。',
        not_enabled: '此社交登录方式未启用。请联系管理员寻求帮助。',
        removed: '已成功移除 {{connector}}。',
        remove_confirmation_title: '移除社交账号',
        remove_confirmation_description: '如果你移除 {{connector}}，在重新添加之前，你可能无法再通过它登录。',
    },
    password: {
        title: '设置密码',
        description: '创建新密码以保护你的账号安全。',
        success: '密码更新成功。',
    },
    code_verification: {
        send: '发送验证码',
        resend: '还没有收到？<a>重新发送验证码</a>',
        resend_countdown: '还没有收到？{{seconds}} 秒后可重新发送',
    },
    email_verification: {
        title: '验证您的邮箱',
        prepare_description: '为保护账户安全，请确认是您本人。发送验证码到您的邮箱。',
        email_label: '邮箱地址',
        send: '发送验证码',
        description: '验证码已发送至您的邮箱 {{email}}。请输入验证码以继续。',
        resend: '还没有收到？<a>重新发送验证码</a>',
        not_received: '还没有收到？',
        resend_action: '重新发送验证码',
        resend_countdown: '还没有收到？{{seconds}} 秒后可重新发送',
        error_send_failed: '验证码发送失败，请稍后再试。',
        error_verify_failed: '验证失败，请重新输入验证码。',
        error_invalid_code: '验证码无效或已过期。',
    },
    phone_verification: {
        title: '验证您的手机',
        prepare_description: '为保护账户安全，请确认是您本人。发送验证码到您的手机。',
        phone_label: '手机号码',
        send: '发送验证码',
        description: '验证码已发送至您的手机 {{phone}}。请输入验证码以继续。',
        resend: '还没有收到？<a>重新发送验证码</a>',
        resend_countdown: '还没有收到？{{seconds}} 秒后可重新发送',
        error_send_failed: '验证码发送失败，请稍后再试。',
        error_verify_failed: '验证失败，请重新输入验证码。',
        error_invalid_code: '验证码无效或已过期。',
    },
    mfa: {
        totp_already_added: '你已添加过身份验证器应用，请先移除现有的。',
        totp_not_enabled: '身份验证器应用 OTP 未启用。请联系管理员寻求帮助。',
        backup_code_already_added: '你已拥有有效的备份码，请先使用或移除它们再生成新的。',
        backup_code_not_enabled: '备份码未启用。请联系管理员寻求帮助。',
        backup_code_requires_other_mfa: '备份码需要先设置其他 MFA 方式。',
        passkey_not_enabled: '通行密钥未启用。请联系管理员寻求帮助。',
        passkey_already_registered: '此通行密钥已绑定到您的账户，请使用其他认证器。',
    },
    update_success: {
        default: {
            title: '更新成功',
            description: '你的更改已成功保存。',
        },
        email: {
            title: '邮箱地址已更新！',
            description: '你的账号邮箱地址已成功更改。',
        },
        phone: {
            title: '手机号已更新！',
            description: '你的账号手机号已成功更改。',
        },
        username: {
            title: '用户名已更新！',
            description: '你的账号用户名已成功更改。',
        },
        password: {
            title: '密码已更新！',
            description: '你的账号密码已成功更改。',
        },
        totp: {
            title: '身份验证器应用已添加！',
            description: '身份验证器应用已成功关联到你的账号。',
        },
        totp_replaced: {
            title: '身份验证器应用已替换！',
            description: '你的身份验证器应用已成功替换。',
        },
        backup_code: {
            title: '备用码已生成！',
            description: '您的备用码已保存。请将它们保存在安全的地方。',
        },
        passkey: {
            title: '通行密钥已添加！',
            description: '通行密钥已成功关联到你的账号。',
        },
        social: {
            title: '社交账号已关联！',
            description: '社交账号已成功关联到你的账号。',
        },
    },
    backup_code: {
        title: '备用码',
        description: '如果您在两步验证时遇到问题，可以使用这些备用码中的一个来访问您的帐户。每个代码只能使用一次。',
        copy_hint: '请务必复制并保存在安全的地方。',
        generate_new_title: '生成新的备用码',
        generate_new: '生成新的备用码',
    },
    passkey: {
        title: '通行密钥',
        added: '添加时间：{{date}}',
        last_used: '上次使用：{{date}}',
        never_used: '从未使用',
        unnamed: '未命名的通行密钥',
        renamed: '通行密钥已重命名。',
        deleted: '通行密钥已移除。',
        add_another_title: '添加另一个通行密钥',
        add_another_description: '使用设备生物识别、安全密钥（例如 YubiKey）或其他可用方法注册您的通行密钥。',
        add_passkey: '添加通行密钥',
        delete_confirmation_title: '移除您的通行密钥',
        delete_confirmation_description: '如果您移除此通行密钥，您将无法使用它进行验证。',
        rename_passkey: '重命名通行密钥',
        rename_description: '为此通行密钥输入新名称。',
        name_this_passkey: '为此设备通行密钥命名',
        name_passkey_description: '您已成功验证此设备用于两步验证。自定义名称以便在拥有多个密钥时进行识别。',
        name_input_label: '名称',
    },
    sessions: {
        page_title: '会话',
        page_description: '管理你的活跃会话和已授权的第三方应用。',
        title: '会话',
        current_session: '当前会话',
        signed_in_at: '登录于 {{date}}',
        revoke_session: '退出登录',
        revoke_session_title: '退出会话',
        revoke_session_description: '这将退出该会话并撤销所有关联的访问权限。确定要继续吗？',
        no_other_sessions: '没有其他活跃会话。',
        loading: '加载中...',
        third_party_apps_title: '第三方应用',
        no_third_party_apps: '没有已授权的第三方应用。',
        third_party_apps_load_failed: '第三方应用加载失败，请重试。',
        granted_at: '授权于 {{date}}',
        dynamic_app: '动态应用',
        client_id: '客户端 ID: {{clientId}}',
        revoke_grant: '移除',
        revoke_grant_title: '移除第三方应用访问权限',
        revoke_grant_description: '这将撤销授予该应用的访问权限。此前已签发的访问令牌可能在过期前仍然有效。确定要继续吗？',
        revoke_grant_failed: '部分授权撤销失败，请重试。',
    },
};
export default Object.freeze(account_center);
